import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=27838a1a&scoped=true&"
import script from "./home-page.js?vue&type=script&lang=js&"
export * from "./home-page.js?vue&type=script&lang=js&"
import style0 from "./home-page.scss?vue&type=style&index=0&id=27838a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27838a1a",
  null
  
)

component.options.__file = "home-page.vue"
export default component.exports